import React from "react";

interface Props
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  title: string;
  other?: any;
  type?: "DOT" | "LINE" | null;
  wrapperClass?: string | undefined;
  dotClass?: string;
  hideLinesOnResponsive?: string;
}

export default function title({
  title,
  wrapperClass,
  dotClass,
  type = "LINE",
  hideLinesOnResponsive,
  ...other
}: Props): JSX.Element {
  return (
    <h2
      {...other}
      className={`relative flex items-center text-[13px] font-bold text-[#3D3C3C] md:text-[20px] ${wrapperClass}`}
    >
      {type == "DOT" && (
        <div
          className={`ml-2 h-[14px] w-[14px] rounded-full bg-blue-550 ${dotClass}`}
        />
      )}
      {title}
      {type == "LINE" && (
        <div className={`mr-5 flex ${hideLinesOnResponsive}`}>
          <div className="h-[2px] w-6 bg-blue-550 md:w-10 lg:w-14" />
          <div className="mx-2 h-[2px] w-4 bg-blue-550 md:w-8 lg:w-10" />
          <div className="ml-2 h-[2px] w-1 bg-blue-550 lg:w-2" />
          <div className="h-[2px] w-8 bg-blue-550 md:w-14 lg:w-20" />
        </div>
      )}
    </h2>
  );
}
